"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function cix(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M17.7174 13.911L16.9231 13.4138L18.6556 13.3935L18.6916 13.374V13.3928L19.4071 13.3853L18.1929 15.3608L18.0841 14.4083L12.5611 17.4555L10.4664 14.6588L4.59387 17.7533V17.0483L10.6486 13.8585L12.7426 16.6553L17.7181 13.911H17.7174ZM10.1334 13.2323L7.83837 14.4405V6.24677H10.1334V13.2323ZM16.6231 13.593L14.3281 14.868V6.24677H16.6231V13.593Z", fill: color }),
        React.createElement("path", { opacity: 0.5, d: "M13.3784 15.396L12.8856 15.669L11.0826 13.2615V7.18427H13.3776V15.396H13.3784ZM6.8879 14.9408L4.5929 16.1498V8.24777H6.8879V14.9408Z", fill: color }));
}
exports["default"] = cix;
//# sourceMappingURL=cix.js.map